/* global newrelic */
export const rentalApiSources = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('rental-api-sources.error', ({ output }) => {
    const { rentalErrorType, rentalMessage, rentalEndpoint } = output;
    if (typeof newrelic !== 'undefined') {
      // newrelic.noticeError(message);
      newrelic.addPageAction('RentalApiError', {
        rentalErrorType,
        rentalMessage,
        rentalEndpoint
      });
    }
  });
};
